import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getProducts, getCategories } from '../api';
import { useCart } from '../context/AppContext';
import { Loading, Empty } from '../components/UI';

export default function ProductsScreen() {
  const navigate      = useNavigate();
  const { cartCount } = useCart();
  const [products, setProducts]   = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading]     = useState(true);
  const [search,  setSearch]      = useState('');
  const [category,setCategory]    = useState('');

  useEffect(() => {
    getCategories().then(({ data }) => setCategories(data.categories)).catch(() => {});
  }, []);

  useEffect(() => {
    setLoading(true);
    const params = {};
    if (search)   params.search   = search;
    if (category) params.category = category;
    getProducts(params)
      .then(({ data }) => setProducts(data.products))
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));
  }, [search, category]);

  return (
    <div className="page">
      <div className="page-hdr">
        <div>
          <div className="page-title">Products</div>
          <div className="page-sub">Select a product to add to the order</div>
        </div>
        <div style={{ display:'flex', gap:8, alignItems:'center' }}>
          <select className="select" style={{ width:140, fontSize:12 }} value={category} onChange={e => setCategory(e.target.value)}>
            <option value="">All categories</option>
            {categories.map(c => <option key={c}>{c}</option>)}
          </select>
          <input className="input" style={{ width:180, fontSize:12 }} placeholder="🔍 Search…" value={search} onChange={e => setSearch(e.target.value)} />
          {cartCount > 0 && (
            <button className="btn btn-primary" onClick={() => navigate('/cart')}>
              Cart · {cartCount}
            </button>
          )}
        </div>
      </div>

      {loading ? <Loading label="Loading products…" /> : products.length === 0
        ? <Empty icon="📦" title="No products found" subtitle="Contact your administrator to add products" />
        : (
          <div className="grid3">
            {products.map(p => (
              <div key={p.id} className="card pcard" onClick={() => navigate(`/product/${p.id}`, { state: { product: p } })}>
                <div className="pcard-thumb">
                  {p.imageUrl
                    ? <img src={p.imageUrl} alt={p.name} />
                    : <span style={{ fontSize:13, color:'var(--text3)', padding:'0 12px', textAlign:'center' }}>{p.name}</span>
                  }
                </div>
                {p.category && <div style={{ fontSize:11, color:'var(--text3)', marginBottom:3 }}>{p.category}</div>}
                <div style={{ fontSize:14, fontWeight:600, marginBottom:3 }}>{p.name}</div>
                <div style={{ fontSize:11, color:'var(--text3)', marginBottom:4 }}>SKU: {p.sku}</div>
                {p.description && <div style={{ fontSize:12, color:'var(--text2)', marginBottom:8 }}>{p.description.slice(0,80)}{p.description.length>80?'…':''}</div>}
                <div style={{ fontSize:18, fontWeight:700, color:'var(--brand)' }}>${p.retailPrice.toFixed(2)}</div>
              </div>
            ))}
          </div>
        )
      }
    </div>
  );
}
